import React from "react";
import { Formik } from "formik";
import Yup from "yup";
import { connect } from "react-redux";
import { login } from "../redux/actionCreators";
import SupportingText from "../SupportingText";
import LeadingText from "../LeadingText";
import TextInput from "../TextInput";
import FlatActionButton from "../FlatActionButton";
import GentleFadeIn from "../Animations/FadeIn";
import MaybeRedirectToOrigin from "../Routing/MaybeRedirectToOrigin";
import { only } from "../utils";

const mapStateToProps = ({ auth }) => ({
  authStatus: auth.authStatus
});

const mapDispatchToProps = dispatch => ({
  loginUser: userValues => {
    dispatch(login(userValues));
  }
});

const LoginValidationSchema = Yup.object().shape({
  clientID: Yup.string().required("Bitte geben Sie Ihre Kundennummer ein."),
  password: Yup.string().required("Bitte geben Sie Ihr Passwort ein.")
});

const FormTextInput = ({
  name,
  handleBlur,
  handleChange,
  value,
  placeholder,
  children,
  ...other
}) => {
  return (
    <div className="mt-3">
      <TextInput
        {...other}
        name={name}
        onChange={handleChange}
        onBlur={handleBlur}
        value={value}
        placeholder={placeholder}
        floatingLabel
        fullWidth
      />
      {children}
    </div>
  );
};

const AuthenticationSubmit = ({ isSubmitting }) => {
  return (
    <div className="mt-6">
      <FlatActionButton
        inlineStyle={{
          width: "100%"
        }}
        type="submit"
        disabled={isSubmitting}
      >
        Einloggen
      </FlatActionButton>
    </div>
  );
};

class LoginView extends React.Component {
  textInputProps = [
    "name",
    "placeholder",
    "handleBlur",
    "handleChange",
    "values"
  ];
  formErrorProps = ["name", "touched", "errors"];

  /**
   * Form inputs.
   */
  renderFormTextInput = props => {
    const value = props.values[props.name];
    const type = props.type ? props.type : "text";
    return (
      <FormTextInput
        type={type}
        value={value}
        {...only(props, this.textInputProps)}
      >
        {this.renderFormError({ ...only(props, this.formErrorProps) })}
      </FormTextInput>
    );
  };

  /**
   * Form error.
   */
  renderFormError = ({ name, touched, errors }) => {
    return (
      <GentleFadeIn show={touched[name] && errors[name]}>
        <SupportingText textColor="red-light" textSize="sm">
          {errors[name]}
        </SupportingText>
      </GentleFadeIn>
    );
  };

  /**
   * Form submit.
   */
  renderFormSubmit = () => {
    const { indication } = this.props.authStatus;
    return <AuthenticationSubmit isSubmitting={indication === "loading"} />;
  };

  /**
   * Render authentication Error.
   */
  renderAuthenticationError = authStatus => {
    return (
      authStatus.indication === "error" && (
        <div className="p-3">
          <LeadingText
            textColor="blue"
            textAlign="center"
            fontWeight="normal"
            textSize="base"
          >
            {authStatus.error.message}
          </LeadingText>
        </div>
      )
    );
  };

  /**
   * Form.
   */
  renderForm = ({ handleSubmit, ...other }) => {
    const { authStatus } = this.props;
    return (
      <form onSubmit={handleSubmit} className="w-full">
        <div className="mt-3">
          {this.renderFormTextInput({
            name: "clientID",
            placeholder: "Kundennummer",
            ...other
          })}
          {this.renderFormTextInput({
            name: "password",
            type: "password",
            placeholder: "Passwort",
            ...other
          })}
          {this.renderFormSubmit()}
        </div>
        {this.renderAuthenticationError(authStatus)}
      </form>
    );
  };

  /**
   * Render method.
   */
  render() {
    const { loginUser, authStatus } = this.props;
    const initialValues = {
      clientID: "",
      password: ""
    };
    return (
      <div className="w-full h-full flex flex-col items-center justify-center">
        <div className="w-4/5 md:w-1/2 shadow-md bg-white p-3">
          {authStatus.indication === "loaded" && (
            <MaybeRedirectToOrigin destination="/article" />
          )}
          <Formik
            initialValues={initialValues}
            validationSchema={LoginValidationSchema}
            onSubmit={values => loginUser(values)}
            render={this.renderForm}
          />
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginView);



// WEBPACK FOOTER //
// ./src/LoginView/LoginView.js